import useApi from '../../../services/useApi'
import useFilters from '../../../hook/useFilters'
import moment from 'moment'
import {useState} from 'react'

const useGetCustomers = () => {
  const [dateRange] = useState(() => JSON.parse(localStorage.getItem('selectedDateRange') || '{}'))

  const Api = useApi()

  const initialFilters = {
    page: 1,
    limit: 50,
    sort_by: 'total_profit/-1',
    start_date: dateRange?.startDate ?? moment().subtract(3, 'months').format('YYYY-MM-DD'),
    end_date: dateRange?.endDate ?? moment().format('YYYY-MM-DD'), // includes today,
    search: true,
    customer_group_id: '',
    sales_rep_email: '',
  }

  const {filters, onSearch, setMultipleFilters, onSortingChange, onPageChange, onDateChange} =
    useFilters(initialFilters, {
      sortType: 'number',
    })

  const {data: response, isFetching} = Api.useGetQuery('/analytics/profitability/customers', {
    queryId: 'profitability-list',
    filters: filters,
    isToast: false,
    isErrorPageRedirection: false,
  })

  const onChangeCustomerGroupFilter = (values: any[]) => {
    setMultipleFilters({
      customer_group_id: values?.map((item: {value: string}) => item?.value).join(','),
      page: 1,
    })
  }

  const onChangeSalesRepFilter = (values: any[]) => {
    setMultipleFilters({
      sales_rep_email: values?.map((item: {value: string}) => item?.value).join(','),
      page: 1,
    })
  }

  const onDownloadCSV = async () => {
    const {page, limit, ...restFilters} = filters
    const response: any = await Api.get('/analytics/profitability/customers/csv', {
      filters: restFilters,
    })
    return {
      message: response?.data?.message,
      status: response?.status,
    }
  }

  return {
    profitabilityData: response?.data || [],
    isLoading: isFetching,
    filters,
    onSearch,
    onSortingChange,
    onPageChange,
    pagination: response?.meta?.pagination || {},
    onDateChangeCustomers: onDateChange,
    onChangeCustomerGroupFilter,
    onChangeSalesRepFilter,
    onDownloadCSV,
  }
}

export default useGetCustomers
